import {defineRouting} from 'next-intl/routing';
import {createNavigation} from 'next-intl/navigation';
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'fr', 'ar', 'it', 'ru', 'de', 'sv', 'nl', 'es', 'pt'],

  // Used when no locale matches
  defaultLocale: 'en',
  pathnames :{
    "/": "/",
    "/ebook/beb70021-fa3a-4afa-a248-65b180ceb61d":"/ebook/beb70021-fa3a-4afa-a248-65b180ceb61d",
    "/account/view-pots-evinov": "/account/view-pots-evinov",
    "/account/create-post-evinov": "/account/create-post-evinov",
    "/account/edite-post-evinov": "/account/edite-post-evinov",
    "/blog": {
      en: "/blog",
      fr: "/blog",
      ar: "/مدونة",
      nl: "/blog",
      de: "/blog",
      pt: "/blog",
      sv: "/blogg",
      ru: "/блог",
      it: "/blog",
      es: "/blog",
    },
    "/search": {
      en: "/search",
      fr: "/recherche",
      ar: "/بحث",
      nl: "/zoeken",
      de: "/suche",
      pt: "/pesquisa",
      sv: "/sök",
      ru: "/поиск",
      it: "/cerca",
      es: "/buscar",
    },
    "/account": {
      en: "/account",
      fr: "/compte",
      ar: "/الحساب",
      nl: "/account",
      de: "/konto",
      pt: "/conta",
      sv: "/konto",
      ru: "/аккаунт",
      it: "/account",
      es: "/cuenta",
    },
    "/account/create-post": {
      en: "/account/create-post",
      fr: "/compte/creer-article",
      ar: "/الحساب/إنشاء-منشور",
      nl: "/account/nieuw-bericht",
      de: "/konto/beitrag-erstellen",
      pt: "/conta/criar-post",
      sv: "/konto/skapa-inlagg",
      ru: "/аккаунт/создать-пост",
      it: "/account/crea-articolo",
      es: "/cuenta/crear-publicacion",
    },
    "/account/edite-post": {
      en: "/account/edite-post",
      fr: "/compte/modifier-article",
      ar: "/الحساب/تعديل-منشور",
      nl: "/account/bewerken-bericht",
      de: "/konto/beitrag-bearbeiten",
      pt: "/conta/editar-post",
      sv: "/konto/redigera-inlagg",
      ru: "/аккаунт/редактировать-пост",
      it: "/account/modifica-articolo",
      es: "/cuenta/editar-publicacion",
    },
    "/account/create-product": {
      en: "/account/create-product",
      fr: "/compte/creer-produit",
      ar: "/الحساب/إنشاء-منتج",
      nl: "/account/nieuw-product",
      de: "/konto/produkt-erstellen",
      pt: "/conta/criar-produto",
      sv: "/konto/skapa-produkt",
      ru: "/аккаунт/создать-товар",
      it: "/account/crea-prodotto",
      es: "/cuenta/crear-producto",
    },
    "/account/edite-product": {
      en: "/account/edite-product",
      fr: "/compte/modifier-produit",
      ar: "/الحساب/تعديل-منتج",
      nl: "/account/bewerken-product",
      de: "/konto/beitrag-erstellen",
      pt: "/conta/editar-produto",
      sv: "/konto/redigera-produkt",
      ru: "/аккаунт/редактировать-товар",
      it: "/account/modifica-prodotto",
      es: "/cuenta/editar-producto",
    },
    "/account/view-post": {
      en: "/account/view-post",
      fr: "/compte/voir-article",
      ar: "/الحساب/عرض-المنشور",
      nl: "/account/bekijk-bericht",
      de: "/konto/beitrag-anzeigen",
      pt: "/conta/ver-post",
      sv: "/konto/visa-inlagg",
      ru: "/аккаунт/просмотр-поста",
      it: "/account/visualizza-articolo",
      es: "/cuenta/ver-publicacion",
    },
    "/account/view-product": {
      en: "/account/view-product",
      fr: "/compte/voir-produit",
      ar: "/الحساب/عرض-المنتج",
      nl: "/account/bekijk-product",
      de: "/konto/produkt-anzeigen",
      pt: "/conta/ver-produto",
      sv: "/konto/visa-produkt",
      ru: "/аккаунт/просмотр-товара",
      it: "/account/visualizza-prodotto",
      es: "/cuenta/ver-producto",
    },
    "/account/orders": {
      en: "/account/orders",
      fr: "/compte/commandes",
      ar: "/الحساب/الطلبات",
      nl: "/account/bestellingen",
      de: "/konto/bestellungen",
      pt: "/conta/pedidos",
      sv: "/konto/bestallningar",
      ru: "/аккаунт/заказы",
      it: "/account/ordini",
      es: "/cuenta/pedidos",
    },
    "/account/address": {
      en: "/account/address",
      fr: "/compte/adresse",
      ar: "/الحساب/العنوان",
      nl: "/account/adres",
      de: "/konto/adresse",
      pt: "/conta/endereco",
      sv: "/konto/adress",
      ru: "/аккаунт/адрес",
      it: "/account/indirizzo",
      es: "/cuenta/direccion",
    },
    "/account/feedback": {
      en: "/account/feedback",
      fr: "/compte/avis",
      ar: "/الحساب/التقييمات",
      nl: "/account/feedback",
      de: "/konto/feedback",
      pt: "/conta/feedback",
      sv: "/konto/feedback",
      ru: "/аккаунт/отзывы",
      it: "/account/feedback",
      es: "/cuenta/opiniones",
    },
    "/account/informations": {
      en: "/account/informations",
      fr: "/compte/informations",
      ar: "/الحساب/المعلومات",
      nl: "/account/informatie",
      de: "/konto/informationen",
      pt: "/conta/informacoes",
      sv: "/konto/information",
      ru: "/аккаунт/информация",
      it: "/account/informazioni",
      es: "/cuenta/informacion",
    },
    "/account/indexnow": "/account/indexnow",
    "/cart": {
      en: "/cart",
      fr: "/panier",
      ar: "/عربة",
      nl: "/winkelwagen",
      de: "/warenkorb",
      pt: "/carrinho",
      sv: "/varukorg",
      ru: "/корзина",
      it: "/carrello",
      es: "/carrito",
    },
    "/cart/checkout": {
      en: "/cart/checkout",
      fr: "/panier/paiement",
      ar: "/عربة/الدفع",
      nl: "/winkelwagen/afrekenen",
      de: "/warenkorb/kasse",
      pt: "/carrinho/finalizar",
      sv: "/varukorg/kassa",
      ru: "/корзина/оформление",
      it: "/carrello/checkout",
      es: "/carrito/pago",
    },
    "/cart/checkout/checkout-payment": {
      en: "/cart/checkout/payment",
      fr: "/panier/paiement/methode",
      ar: "/عربة/الدفع/الطريقة",
      nl: "/winkelwagen/afrekenen/betaling",
      de: "/warenkorb/kasse/zahlung",
      pt: "/carrinho/finalizar/pagamento",
      sv: "/varukorg/kassa/betalning",
      ru: "/корзина/оплата",
      it: "/carrello/checkout/pagamento",
      es: "/carrito/pago/metodo",
    },
   
    "/p": "/p",
    "/p/[id]": "/p/[id]",
   
    "/privacy-policy": {
      en: "/privacy-policy",
      fr: "/politique-de-confidentialite",
      ar: "/سياسة-الخصوصية",
      nl: "/privacybeleid",
      de: "/datenschutz",
      pt: "/politica-de-privacidade",
      sv: "/integritetspolicy",
      ru: "/политика-конфиденциальности",
      it: "/politica-sulla-privacy",
      es: "/politica-de-privacidad",
    },
    "/product": {
      en: "/product",
      fr: "/produit",
      ar: "/منتج",
      nl: "/product",
      de: "/produkt",
      pt: "/produto",
      sv: "/produkt",
      ru: "/товар",
      it: "/prodotto",
      es: "/producto",
    },
    "/product/[id]": {
      en: "/product/[id]",
      fr: "/produit/[id]",
      ar: "/منتج/[id]",
      nl: "/product/[id]",
      de: "/produkt/[id]",
      pt: "/produto/[id]",
      sv: "/produkt/[id]",
      ru: "/товар/[id]",
      it: "/prodotto/[id]",
      es: "/producto/[id]",
    },
    "/blog/[id]": {
      en: "/blog/[id]",
      fr: "/blog/[id]",
      ar: "/مدونة/[id]",
      nl: "/blog/[id]",
      de: "/blog/[id]",
      pt: "/blog/[id]",
      sv: "/blogg/[id]",
      ru: "/блог/[id]",
      it: "/blog/[id]",
      es: "/blog/[id]",
    },
    "/login-signin": {
      en: "/login-signin",
      fr: "/connexion",
      ar: "/تسجيل-الدخول",
      nl: "/inloggen",
      de: "/anmelden",
      pt: "/entrar",
      sv: "/logga-in",
      ru: "/вход",
      it: "/accedi",
      es: "/iniciar-sesion",
    },
    "/reset-email": {
      en: "/reset-email",
      fr: "/reinitialiser-email",
      ar: "/إعادة-تعيين-البريد",
      nl: "/reset-email",
      de: "/email-zurücksetzen",
      pt: "/redefinir-email",
      sv: "/aterstall-e-post",
      ru: "/сброс-почты",
      it: "/reimposta-email",
      es: "/restablecer-correo",
    },
    "/reset-password": {
      en: "/reset-password",
      fr: "/reinitialiser-mot-de-passe",
      ar: "/إعادة-تعيين-كلمة-المرور",
      nl: "/reset-wachtwoord",
      de: "/passwort-zurücksetzen",
      pt: "/redefinir-senha",
      sv: "/aterstall-losenord",
      ru: "/сброс-пароля",
      it: "/reimposta-password",
      es: "/restablecer-contrasena",
    },
    "/terms-and-conditions": {
      en: "/terms-and-conditions",
      fr: "/conditions-generales",
      ar: "/الشروط-والأحكام",
      nl: "/algemene-voorwaarden",
      de: "/agb",
      pt: "/termos-e-condicoes",
      sv: "/villkor",
      ru: "/условия",
      it: "/termini-e-condizioni",
      es: "/terminos-y-condiciones",
    },
    "/returns-and-refunds": {
      en: "/returns-and-refunds",
      fr: "/retours-et-remboursements",
      ar: "/الإرجاع-والاسترداد",
      nl: "/retouren-en-terugbetalingen",
      de: "/ruckgabe-und-ruckerstattung",
      pt: "/devolucoes-e-reembolsos",
      sv: "/retur-och-aterbetalning",
      ru: "/возвраты-и-возмещение",
      it: "/resi-e-rimborsi",
      es: "/devoluciones-y-reembolsos",
    },
    "/help": {
      en: "/help",
      fr: "/aide",
      ar: "/مساعدة",
      nl: "/hulp",
      de: "/hilfe",
      pt: "/ajuda",
      sv: "/hjalp",
      ru: "/помощь",
      it: "/aiuto",
      es: "/ayuda",
    },
    "/cookies-policy": {
      en: "/cookies-policy",
      fr: "/politique-de-cookies",
      ar: "/سياسة-الكوكيز",
      nl: "/cookiebeleid",
      de: "/cookie-richtlinie",
      pt: "/politica-de-cookies",
      sv: "/cookiepolicy",
      ru: "/политика-файлов-cookie",
      it: "/politica-dei-cookie",
      es: "/politica-de-cookies",
    },
    "/charity": {
      en: "/charity",
      fr: "/charite",
      ar: "/الاعمال-الخيرية",
      nl: "/liefdadigheid",
      de: "/wohlfahrt",
      pt: "/caridade",
      sv: "/valgorande",
      ru: "/благотворительность",
      it: "/beneficenza",
      es: "/caridad",
    },
    "/about-us": {
      en: "/about-us",
      fr: "/a-propos",
      ar: "/معلومات-عنا",
      nl: "/over-ons",
      de: "/uber-uns",
      pt: "/sobre-nos",
      sv: "/om-oss",
      ru: "/о-нас",
      it: "/chi-siamo",
      es: "/sobre-nosotros",
    },
  },
  
});
 
export type Locale = (typeof routing.locales) [number];
// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const {Link, redirect, usePathname, useRouter, getPathname} =
  createNavigation(routing);

 
  export type AppPathname = keyof typeof routing.pathnames;
  export type AppLocale = typeof routing.locales[number]; // 'en' | 'fr' | 'ar' | ...